package api.dataclasses.outbound

import api.interfaces.ICSMarksAllowedFieldParser
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
class OutboundOrderDetailed(
    @SerialName("RecordId") val recordId: Int,
    @SerialName("Eigenaar") val owner: String,
    @SerialName("Aantal_verzendeenheden") val deliveryUnitsAmount: Double,
    @SerialName("Adres") val address: String,
    @SerialName("Artikelgroep") val articleCategory: String,
    @SerialName("Bericht") val message: String,
    @SerialName("Controle_Conform") val manuallyChecked: Boolean,
    @SerialName("Doostype") val boxType: String,
    @SerialName("Eind_datumtijd") val endDateTime: String?,
    @SerialName("Emailadres") val email: String,
    @SerialName("Expediteur") val shippingAgent: String,
    @SerialName("Gepickt_aantal") val pickedAmount: Double,
    @SerialName("Gevraagde_datumtijd") val requestedDateTime: String?,
    @SerialName("Inpakker") val packer: String,
    @SerialName("Inpakstation") val packingStation: String,
    @SerialName("Invoerdatumtijd") val inputDate: String,
    @SerialName("Klant") val customer: String,
    @SerialName("Klantreferentie") val customerReference: String,
    @SerialName("Land") val country: String,
    @SerialName("Naam") val name: String,
    @SerialName("OnHold") val onHold: Boolean,
    @SerialName("Orderdatum") val orderDate: String?,
    @SerialName("Outbound_DVE") val outboundTransportUnit: String,
    @SerialName("Outboundtijd") val outboundTime: String?,
    @SerialName("PARCELSHOPID") val parcelShopId: String,
    @SerialName("Pakbon_Mailadres_extra") val packingSlipEmailExtra: String,
    @SerialName("Pakbon_Mailen") val mailPackingSlip: Boolean,
    @SerialName("Plaats") val city: String,
    @SerialName("Postcode") val zipCode: String,
    @SerialName("Prioriteit") val priority: Boolean,
    @SerialName("Referentie") val reference: String,
    @SerialName("Regiocode") val regionalCode: String,
    @SerialName("Service") val service: String,
    @SerialName("Special") val special: Boolean,
    @SerialName("Speciale_Pakbon") val specialPackingSlip: Boolean,
    @SerialName("Statusomschrijving") val statusDescription: String,
    @SerialName("Te_picken_aantal") val amountToPick: Double,
    @SerialName("Telefoonnummer") val phone: String,
    @SerialName("Tijdelijke_locatie") val temporaryLocation: String,
    @SerialName("Toelichting") val explanation: String,
    @SerialName("Track_Trace") val trackAndTrace: String,
    @SerialName("Uitlevercode") val deliveryCode: String,
    @SerialName("VerdeelzoneStatusOmschrijving") val packingStatus: String,
    @SerialName("Verwerkingsbatch") val batch: Int,
    @SerialName("Verzendeenheden") val deliveryUnits: String,
    @SerialName("Verzendoptie") val deliveryOption: String,
    @SerialName("Verzendvoorstel") val deliveryProposal: String,
    @SerialName("Webshop") val webShop: Boolean,

    @SerialName("Fields") override val fields: Array<String>,
    var lines: Array<OutboundOrderline>? = arrayOf()
) : ICSMarksAllowedFieldParser